export default "<p class=\"divider\"></p>"